import { render, staticRenderFns } from "./ProjectTasklist.vue?vue&type=template&id=3cd56658"
import script from "./ProjectTasklist.vue?vue&type=script&lang=js"
export * from "./ProjectTasklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports